module.exports = {
    VRBO: 'vrbo',
    HA_US: 'homeaway_us',
    HA_UK: 'homeaway_uk'
};
